module.exports = __webpack_public_path__ + "static/media/empty_tickets.b46f7b65.png";